import { render, staticRenderFns } from "./BuyDetail.vue?vue&type=template&id=b8773f2c&scoped=true&"
import script from "./BuyDetail.vue?vue&type=script&lang=js&"
export * from "./BuyDetail.vue?vue&type=script&lang=js&"
import style0 from "./BuyDetail.vue?vue&type=style&index=0&id=b8773f2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8773f2c",
  null
  
)

export default component.exports